import { createContext } from 'react';
import { IProps } from '../../components/Modal/ModalView';

export const ModalViewContext = createContext({
    openModal: (modalConfig: IProps) => {},
    closeModal: () => {},
});
